import * as React from 'react';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';

enum RewardsEducationContentType {
  PARAGRAPH = 'P',
  LIST = 'LI',
  TERMS = 'TERMS',
  SUBHEADER = 'SUBHEADER'
}

interface RewardsEducationContentBodyProps {
  type: string;
  content: any;
  icon?: string;
}

export const RewardsEducationContentBody: React.FunctionComponent<RewardsEducationContentBodyProps> = ({ type, content, icon }) => {
  switch (type) {
    case RewardsEducationContentType.PARAGRAPH:
      return <p className="uitk-type-paragraph-300 all-b-margin-three">{content}</p>;
    case RewardsEducationContentType.SUBHEADER:
      return <h4 className="uitk-type-heading-300 all-b-margin-one uitk-type-bold">{content}</h4>;
    case RewardsEducationContentType.LIST:
      return (
        <div className="all-b-margin-three">
          {icon ? (
            content.map((listItem, index) => (
              <li className="uitk-grid all-t-margin-two" key={index}>
                <UitkIcon name={icon} className="uitk-cell all-cell-shrink all-r-margin-two" size={UitkIconSize.SMALL} />
                <span className="uitk-cell all-cell-3-4 uitk-type-paragraph-300">{listItem}</span>
              </li>
            ))
          ) : (
            <ul className="uitk-type-list-300">
              {content.map((listItem, index) => (
                <li key={index}>{listItem}</li>
              ))}
            </ul>
          )}
        </div>
      );
    case RewardsEducationContentType.TERMS:
      return <p className="uitk-type-paragraph-200 all-b-margin-three" dangerouslySetInnerHTML={{ __html: content }} />;
    default:
      return null;
  }
};
